import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { service } from './reducers/service';
import { order } from './reducers/order';

const rootReducer = combineReducers({
  form: formReducer,
  service,
  order,
});

export default rootReducer;
